import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { Clocking } from '@app/entities/models/mot/clocking/clocking.model';

export interface ClockingUseCases {
  getClockings(): Observable<Clocking>;
}

export const CLOCKING_USE_CASES = new InjectionToken<ClockingUseCases>('CLOCKING_USE_CASES');
